import { useDispatch, useSelector } from "react-redux";
import { setSoundAction, playSoundAction, pauseSoundAction, clearSoundAction } from "../redux/sound";

const getSound = state => state.sound;

const useSound = () => {
  const dispatch = useDispatch();
  const sound = useSelector( getSound );
  const setSound = (data) => {
    dispatch(setSoundAction(data)) 
  };
  const playSound = () => { dispatch( playSoundAction() ) };
  const pauseSound = () => { dispatch( pauseSoundAction() ) };
  const clearSound = () => { dispatch( clearSoundAction() ) };

  return {
    sound,
    setSound,
    playSound,
    pauseSound,
    clearSound
  };

};

export default useSound;
